var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVideoCameraOff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 1920 1920",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1421.141 3.007 91.775 64.262L215.481 1919.55l.595.417-.378.54-92.37-64.679L246.487 1680H0V240h1255.139L1421.141 3.007Zm79.395 278.487V791.83L1920 346.05v1228.01l-419.464-445.892V1680H520.95l979.586-1398.506Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoCameraOff);
export default __webpack_public_path__ + "static/media/icon-video-camera-off.4c61a1762250f5642dfef3203ed1b5ed.svg";
export { ForwardRef as ReactComponent };